import { DateUnit as r, MILLISECONDS_IN_DAY as d } from "../../constants/date.js";
import { getYear as I, intervalToDuration as b, millisecondsToSeconds as y, millisecondsToMinutes as f, millisecondsToHours as k } from "date-fns";
import { millisecondsInMinute as x, millisecondsInHour as T } from "date-fns/constants";
import * as c from "ramda";
import { useCallback as a } from "react";
import { zeroPad as S } from "react-countdown";
import { useTranslation as H } from "react-i18next";
const E = () => {
  const {
    t: h
  } = H(), i = a((t) => c.is(String, t) || c.is(Number, t) ? new Date(t) : t, []), N = a((t) => {
    const n = t / d;
    return Math.floor(n);
  }, []), g = a((t) => {
    const n = i(t), e = I(n);
    return e !== 1970 && !isNaN(e);
  }, [i]), l = a((t, n = r.Second) => {
    if ([r.Year, r.Month].includes(n))
      return b({
        start: /* @__PURE__ */ new Date(),
        end: (/* @__PURE__ */ new Date()).getTime() + t
      });
    switch (n) {
      case r.Day: {
        const e = N(t), o = k(t - e * d), s = f(t - o * T - e * d), m = y(t - s * 6e4 - o * T - e * d);
        return {
          days: e,
          hours: o,
          minutes: s,
          seconds: m
        };
      }
      case r.Hour: {
        const e = k(t), o = f(t - e * T), s = y(t - o * x - e * T);
        return {
          hours: e,
          minutes: o,
          seconds: s
        };
      }
      case r.Minute: {
        const e = f(t), o = y(t - e * x);
        return {
          minutes: e,
          seconds: o
        };
      }
      case r.Second:
      default:
        return {
          seconds: y(t)
        };
    }
  }, []), u = a((t, n = r.Second) => {
    const {
      time: e = null,
      duration: o = 0
    } = t, s = e ? i(e).getTime() - (/* @__PURE__ */ new Date()).getTime() : o;
    return l(s, n);
  }, [i, l]), p = a((t) => {
    const {
      seconds: n
    } = u(t);
    return h("common.date.time_ago", {
      count: n
    });
  }, [h, u]), w = a((t, n = "’ ", e = "” ") => {
    const {
      hours: o = 0,
      minutes: s = 0,
      seconds: m = 0
    } = u(t, r.Hour);
    return S(o) + n + S(s) + e + S(m);
  }, [u]);
  return {
    dateValid: g,
    timeFromNow: u,
    textTimeAgo: p,
    textTimeWithSeparator: w,
    textTimeSharp: (t, n) => {
      const e = u(t, (n == null ? void 0 : n.maxUnit) ?? r.Day), o = [{
        key: "years",
        i18nKey: "year"
      }, {
        key: "months",
        i18nKey: "month"
      }, {
        key: "days",
        i18nKey: "day"
      }, {
        key: "hours",
        i18nKey: "hour"
      }, {
        key: "minutes",
        i18nKey: "minute"
      }, {
        key: "seconds",
        i18nKey: "second"
      }];
      return c.pipe(c.map((m) => {
        const {
          key: K,
          i18nKey: M
        } = m, D = c.prop(K, e);
        return !c.isNil(D) && D > 0 ? h(`common.i18n_format.${M}`, {
          count: D,
          context: n != null && n.shortForm ? "short" : void 0
        }) : "";
      }), c.reject(c.isEmpty), c.join(" "))(o);
    }
  };
};
export {
  E as default
};
//# sourceMappingURL=useDate.js.map
